/**
 * Centralized Create React App environment variables (`REACT_APP_*`).
 * Values are read at build time from `.env` — restart `npm start` after changes.
 */

import {
  GENERAL_INQUIRIES_EMAIL as DEFAULT_GENERAL_INQUIRIES_EMAIL,
  PRIVACY_EMAIL as DEFAULT_PRIVACY_EMAIL,
  WITHDRAWAL_NOTICE_EMAIL as DEFAULT_WITHDRAWAL_NOTICE_EMAIL,
} from "lib/fortifyContact";

function trimEnv(value) {
  return String(value ?? "").trim();
}

/** Read a `REACT_APP_*` (or other) env key with optional fallback. */
export function envString(key, fallback = "") {
  const value = trimEnv(process.env[key]);
  return value || fallback;
}

/**
 * Empty `REACT_APP_API_BASE_URL` in dev ⇒ default backend on port 5000
 * so `/api/...` is not sent to CRA :3000.
 */
export const API_BASE_URL = (
  envString("REACT_APP_API_BASE_URL") ||
  (process.env.NODE_ENV === "development" ? "http://localhost:5000" : "")
).replace(/\/+$/, "");

export const AUTH_STORAGE_KEY = envString("REACT_APP_AUTH_STORAGE_KEY", "token");

export const REFRESH_TOKEN_STORAGE_KEY = envString(
  "REACT_APP_REFRESH_TOKEN_STORAGE_KEY",
  "refreshToken",
);

/** General inquiries (login prefill, public contact). */
export const GENERAL_INQUIRIES_EMAIL = envString(
  "REACT_APP_GENERAL_INQUIRIES_EMAIL",
  DEFAULT_GENERAL_INQUIRIES_EMAIL,
);

/** Withdrawal and cancellation notices. */
export const WITHDRAWAL_NOTICE_EMAIL = envString(
  "REACT_APP_WITHDRAWAL_NOTICE_EMAIL",
  DEFAULT_WITHDRAWAL_NOTICE_EMAIL,
);

/** Privacy inquiries. */
export const PRIVACY_EMAIL = envString("REACT_APP_PRIVACY_EMAIL", DEFAULT_PRIVACY_EMAIL);

/**
 * @deprecated Use `GENERAL_INQUIRIES_EMAIL`. Kept for `REACT_APP_SUPPORT_EMAIL` overrides.
 */
export const SUPPORT_EMAIL =
  envString("REACT_APP_SUPPORT_EMAIL") || GENERAL_INQUIRIES_EMAIL;

/** User Portal base URL for public campaign pages (used for share links). */
export const USER_PORTAL_URL = envString(
  "REACT_APP_USER_PORTAL_URL",
  "https://user-portal.fortifyportal.ca",
).replace(/\/+$/, "");

/**
 * PDF / Word uploads (offering docs). Image-only route is `uploadFile`.
 * Falls back to `/api/uploads/upload-file` in `API_ENDPOINTS` when empty.
 */
export const UPLOAD_DOCUMENT_PATH = envString("REACT_APP_UPLOAD_DOCUMENT_PATH");

/** Fixed maximum investment per investor (read-only on project form). */
export const FIXED_MAXIMUM_INVESTMENT_AMOUNT =
  envString("REACT_APP_FIXED_MAXIMUM_INVESTMENT_AMOUNT", "2500") || "2500";
